<template>
<v-container>
  <h1 class="text-center my-4">Our Main Features</h1>

  <v-row class="my-5">
    <v-col v-for="(feature, index) in features" :key="index" md="4" lg="4" cols="12">
      <v-card class="feature p-4"  max-width="100%" height="100%" >
        <div>
          <v-img :src="feature.image" height="200" width="100%" />
        </div>
        <h2 class="text-center mt-3 header">
          {{feature.title}}
        </h2>
        <v-card-subtitle class="normal-text">
          {{feature.subTitle}}
        </v-card-subtitle>
      </v-card>
    </v-col>
  </v-row>
</v-container>
</template>

<script>

import Mentor from "@/assets/landing_page/mentor.svg";
import OneOnOne from "@/assets/landing_page/one_on_one.svg";
import Recommendation from "@/assets/landing_page/recommendation.svg";
import Assessments from "@/assets/landing_page/assessments.svg";
import VideoCourse from "@/assets/landing_page/video_courses.svg";
import Curriculum from "@/assets/landing_page/curriculum.svg";

export default {
  name: "Features",
  data() {
    return {
      features: [
        {title: "Blog posts",
          subTitle: "Access different blog posts cutting across different sectors, subjects and so many others.",
          image: Mentor
        },
        {title: "Video courses",
          subTitle: "Have a seamless experience of learning with our experts.",
          image: VideoCourse
        },
        {title: "One on One Video Calls",
          subTitle: "Book your favorite mentor and get mentored in real-time in any subject.",
          image: OneOnOne
        },
        {title: "Recommendations",
          subTitle: "Get Recommendations on videos, books or mentors to help you on your learning journey.",
          image: Recommendation
        },
        {
          title: "Assessments",
          subTitle: "Tryout assessments to check your understanding of resources learnt.",
          image: Assessments
        },
        {title: "School Curriculum",
          subTitle: "Have access to the school curriculum per country as its updated.",
          image: Curriculum
        }
      ]
    }
  }
}
</script>

<style lang="scss" scoped>
.feature {
  cursor: pointer;
  text-align: center;
}

.normal-text {
  font-size: 1.2em;
}

.header {
  color: #0033AA;
}
</style>
